import React from 'react';
import { bookingModeSelector } from 'helper/filter';
import { EBookingMode } from 'types';
import { mountBoeiChat, unmountBoeiChat } from 'semshared/utils/boeiWidget';

/**
 * Mounts the BOEI chat widget (replaces Smartsupp) only while the backoffice is
 * in EPILO booking mode. Renders nothing — the widget lives in document.body.
 */
const BoeiChatWidget = (): null => {
  const bookingMode = bookingModeSelector();

  React.useEffect(() => {
    if (bookingMode === EBookingMode.EPILO) {
      mountBoeiChat();
    } else {
      unmountBoeiChat();
    }
    return () => {
      unmountBoeiChat();
    };
  }, [bookingMode]);

  return null;
};

export default BoeiChatWidget;
